
export enum SortDirections {
  ASC = 'ASC',
  DESC = 'DESC',
}
